import React, { useState } from 'react'
import Image from '../../components/image'
import Link from '../../components/link'
import HomeSliderProduct from './home-slider-product';
import { gql, useQuery } from '@apollo/client';
import Arrow from '-!svg-react-loader!../../assets/images/arrow.svg';

const HomeSliderItem = ({ slide, slideIndex, slideCount, swiper }) => {
  const [activeProd, setActiveProd] = useState(null);

  const GET_PRODUCTS = gql`
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ...on Product {
          createdAt
          vendor
          title
          handle
          featuredImage {
            altText
            src
          }
          priceRange {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
        }
      }
    }
  `

  const {data: prods} = useQuery(GET_PRODUCTS, {
    skip: !slide || !slide.hasProduct,
    variables: {
      ids: slide?.product?.products?.map(prod => `gid://shopify/Product/${prod.productCode}`)
    },
  })

  if (!slide) { return null }

  return (
    <div className="Container">
      <div className="Slide__content col-5">
        <h2 className="Slide__title" dangerouslySetInnerHTML={{ __html: slide.title }} />
        <div className="Slide__description" dangerouslySetInnerHTML={{ __html: slide.text }} />
        {slide.button1 && (
          <Link to={slide.button1.url} className="Button Button__primary">{slide.button1.title}</Link>
        )}
        {slide.button2 && (
          <Link to={slide.button2.url} className="Button Button__primary--outline">{slide.button2.title}</Link>
        )}
        <div className="Slide__nav">
          <button
            className="Slide__nav__button prev"
            onClick={() => swiper.slidePrev()}
            aria-label="Previous slide"
          ><Arrow /></button>
          <div className="swiper-pagination">
            {[...Array(slideCount)].map((bullet, index) => (
              <span
                className={`swiper-pagination-bullet${slideIndex === index ? ' swiper-pagination-bullet-active' : ''}`}
                key={index}
                onClick={() => swiper?.slideTo(index + 1)}
                onKeyUp={() => swiper?.slideTo(index + 1)}
                role="button"
                tabIndex="0"
                aria-label={`Go to slide ${index + 1}`}
              ></span>
            ))}
          </div>
          <button
            className="Slide__nav__button next"
            onClick={() => swiper.slideNext()}
            aria-label="Next slide"
          ><Arrow /></button>
        </div>
      </div>
      <div className="col-7 Slide__image">
        <Image source={slide.image} loading={slideIndex === 0 ? 'eager' : 'lazy'}  tabIndex={0}/>
        {prods?.nodes?.map((prod, index) => (
          <HomeSliderProduct
            prod={prod}
            position={slide.product?.products[index]}
            key={index}
            activeProd={activeProd}
            setActiveProd={setActiveProd}
            index={index}
          />
        ))}
      </div>
    </div>
  )
}

export default HomeSliderItem